module.exports = __webpack_public_path__ + "img/2.af3336a8.jpg";